import { moment } from '@hotjar/insights-common/lib/moment';

interface getDownloadFilenameParams {
  ext: string;
  siteId: string;
  type: HeatmapDataType;
  device: HeatmapDeviceTypes;
}

export const getDownloadFilename = ({
  ext,
  siteId,
  type,
  device,
}: getDownloadFilenameParams): string =>
  `${[
    'Hotjar',
    'Heatmap',
    siteId,
    `${type} on ${device}`,
    moment().format('YYYY-MM-DD HH:mm:ss'),
  ].join(' - ')}.${ext}`;
